/**
 *
 * Please note:
 * This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit this file manually.
 *
 */

@file:Suppress(
    "ArrayInDataClass",
    "EnumEntryName",
    "RemoveRedundantQualifierName",
    "UnusedImport"
)

package org.openapitools.client.models

import org.openapitools.client.models.NewLoop

import kotlinx.serialization.*
import kotlinx.serialization.descriptors.*
import kotlinx.serialization.encoding.*

/**
 *
 *
 * @param id
 * @param title
 * @param components
 * @param componentsDetails
 */
@Serializable
data class GetNewLoopDetails (

    @SerialName(value = "id") val id: kotlin.String? = null,

    @SerialName(value = "title") val title: kotlin.String? = null,

    @SerialName(value = "components") val components: kotlin.collections.List<NewLoop>? = null,

    @SerialName(value = "componentsDetails") val componentsDetails: kotlin.collections.List<SaveLoopDataInDb>? = null

)

